// API Configuration
const config = {
  // Use environment variable or fallback
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000',
  
  // Get API URL based on environment
  getApiUrl: () => {
    return import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
  }
};

export default config;